import { Font, TextLink } from "@moneyforward/mfx_biz_react_components";

type Props = {};

export const Introduction: React.FC<Props> = ({}: Props) => {
  return (
    <div>
      <Font>
        マネーフォワードエックス株式会社（以下「当社」といいます。）が発行する
        <span>Mikatano ID</span>
        の認証機能を利用する各種サービスのうち当社が指定するサービス（第1条に定義するものをいい、以下「指定サービス」といいます。）をご利用する場合には、「指定サービスに関する特約」（以下「本特約」といいます。）が適用されます。
      </Font>
      <Font>
        本特約については、利用希望者（指定サービスを利用するに際し、当社と指定サービスの利用に関する契約を締結することを希望する法人、団体又は個人事業主をいいます。以下同じです。）が利用登録した時点で同意したものとさせていただきますので、ご利用の前に必ずお読みください。
      </Font>
      <Font>
        なお、本特約が
        <TextLink href="/terms/id" target="_blank">
          Mikatano ID利用規約
        </TextLink>
        及び指定サービスの利用にあたり利用者に適用される利用規約と抵触する場合には、本特約が優先するものとし、本特約の中で使用される用語については、本特約中に別段の定めのある場合を除き、指定サービス利用規約の中で使用される定義、
        <span>Mikatano ID</span>
        利用規約で使用される定義の順で適用されるものとします。
      </Font>
    </div>
  );
};
